import _ from "lodash";
import routes from "../../../routes";
import { matchPath } from "react-router";

const _getRouteParams = _.memoize(pathname => {
  for (let key in routes) {
    const route = routes[key];
    const match = matchPath(pathname, {
      path: route.path,
      exact: true,
      strict: false
    });
    if (match) {
      return { route, match };
    }
  }
});

export default function getRouteParams(location) {
  return location ? _getRouteParams(location.pathname) : null;
}
